export const baseUrl = 'https://assessify.onrender.com/'